module.exports = __webpack_public_path__ + "static/candyCane-7c3f9dc09625af894ba9eee4c0d81135.png";